(function() {
  var ANIMATED_ATTR = 'data-el-compare-animated';

  function animateSection(section) {
    if (section.getAttribute(ANIMATED_ATTR) === 'true') return;
    section.setAttribute(ANIMATED_ATTR, 'true');

    var circles = section.querySelectorAll('.el-percentage-circle');
    var bars = section.querySelectorAll('.el-card-compare__bar-fill');
    circles.forEach(function(fig) {
      var val = fig.querySelector('.el-percentage-circle__value');
      if (val && val.dataset.value !== undefined) {
        var pct = parseInt(val.dataset.value, 10) || 0;
        val.textContent = pct + '%';
        var fill = fig.querySelector('.el-percentage-circle__fill');
        if (fill) {
          var r = 45;
          var c = 2 * Math.PI * r;
          fill.style.strokeDasharray = c;
          fill.style.strokeDashoffset = c - (c * pct / 100);
        }
      }
    });
    bars.forEach(function(bar) {
      var pct = parseFloat(bar.style.getPropertyValue('--pct')) || 0;
      bar.style.width = pct + '%';
    });
  }

  function runWhenVisible() {
    var sections = document.querySelectorAll('.el-compare-guarantee');
    if (typeof IntersectionObserver === 'undefined') {
      sections.forEach(animateSection);
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          animateSection(e.target);
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '50px', threshold: 0 });
    sections.forEach(function(s) { io.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenVisible);
  } else {
    runWhenVisible();
  }
})();
